export enum PlasticsOrderedProductStatus {
    Draft = 'Draft',
    Scheduled = 'Scheduled',
    Released = 'Released',
    Hold = 'Hold',
    Complete = 'Complete',
    Canceled = 'Canceled',
    ToBeCanceled = 'ToBeCanceled',
    Blanket = 'Blanket'
}